
// importing directly prevents the entire lib from being bundled
// when imported the bootstrap-data api is enabled on load; no need to init most of these


import Collapse from 'bootstrap/js/dist/collapse';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab';
import Alert from 'bootstrap/js/dist/alert';
import Popover from 'bootstrap/js/dist/popover';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Carousel from 'bootstrap/js/dist/carousel';

export const initBootstrap = function (config = {}) {

    config = {

        // everything is off by default
        tooltip: false,
        popover: false,
        dropdown: false,
        offcanvas: false,
        dropdown: false,
        collapse: false,
        alert: false,
        tab: false,

        // define the containers where JS will be applied
        scope: '.art-theme-bs5',

        // merge in extras
        ...config
    };


    // Enabling tooltips
    if (config.tooltip) {

        // @todo apply scoping later
        //const tooltipTriggerList = [].slice.call(document.querySelectorAll(`${config.scope} [data-bs-toggle="tooltip"]`));
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        popoverTriggerList.map(function (popoverTriggerEl) {
            return new Popover(popoverTriggerEl)
        });
    }

    if (config.offcanvas) {

        const offcanvasMenu = document.getElementById('nav-menu');
        if (offcanvasMenu) {
            const offcanvasMenuBody = offcanvasMenu.querySelector('.offcanvas-body');
            offcanvasMenu.addEventListener('hidden.bs.offcanvas', event => {
                // if the menu has been scrolled then take it back to the top
                offcanvasMenuBody.scrollTop = 0;
            });
        }
    }    

    if (config.dropdown) {

        // find all dropdowns with arrows; custom variant of dropdown
        // replicates popper look and feel with the top arrow
        const dropdownElementList = document.querySelectorAll('.dropdown-with-arrow');
        [...dropdownElementList].map(dropdownToggleEl => {

            // find the arrow and dropdown elements
            let arrow = dropdownToggleEl.querySelector('.dropdown-arrow');
            let toggle = dropdownToggleEl.querySelector('.dropdown-toggle');
            let menu = dropdownToggleEl.querySelector('.dropdown-menu');

            // instantiate with custom popperJs config
            let currentDropdown = Dropdown.getOrCreateInstance(toggle, {
                popperConfig: {
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                flipVariations: false,
                            },
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 8],
                            },
                        },
                        {
                            name: 'arrow',                            
                            options: {
                                element: arrow,
                                // dynamically add padding to keep the dropdown arrow positioned correctly to the toggle
                                padding: ({ popper, reference, placement }) => {

                                    // adding dropdown padding affects the arrow placement
                                    // we attempt to keep the arrow where it should be relative to the toggle
                                    // arrow must stay inside this box
                                    let { left: toggleLeft } = toggle.getBoundingClientRect();
                                    let { left: dropdownLeft } = menu.getBoundingClientRect();

                                    return {
                                        left: ((toggleLeft - dropdownLeft) + (reference.width / 2) + 8)
                                    }
                                }
                                
                            },
                        },
                        {
                            name: 'computeStyles',
                            options: {

                                // dynamically add padding to prevent the dropdown touching the side in smaller devices
                                roundOffsets: ({ x, y }) => ({
                                    // prevent popper touching the edge on smaller screens                              
                                    x: x - 16,
                                    y
                                }),
                            },
                        },
                    ],
                }
            });

            // listen for dropdown to show
            toggle.addEventListener('show.bs.dropdown', event => {

                // give the DOM time to display
                setTimeout(() => {

                    // update will use the calculated padding from the modifier
                    currentDropdown.update();
                }, 2);               
            });
            
        });
    }
}
